/**
 * Armenian dram.
 */
export var AMD = {
  code: 'AMD',
  base: 10,
  exponent: 2
};